<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M9.62,12L12,5.67L14.37,12M11,3L5.5,17H7.75L8.87,14H15.12L16.25,17H18.5L13,3H11Z"/>
    </svg>
</template>

<script>
export default {
    name: 'FormatColorTextIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
